import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../AppContextProvider";
import { motion } from "framer-motion";

import error from "../assets/media/icons/stop-outline.svg";
import done from "../assets/media/icons/checkedbox-small.svg";
import info from "../assets/media/icons/info-outline.svg";
import warning from "../assets/media/icons/warning-outline.svg";
import error_dark from "../assets/media/icons/stop-outline-white.svg";
import done_dark from "../assets/media/icons/checkedbox-small-white.svg";
import info_dark from "../assets/media/icons/info-outline-white.svg";
import warning_dark from "../assets/media/icons/warning-outline-white.svg";
import close_done from "../assets/media/icons/cross-thin-done.svg";
import close_error from "../assets/media/icons/cross-thin-error.svg";
import close_info from "../assets/media/icons/cross-thin-info.svg";
import close_warning from "../assets/media/icons/cross-thin-warning.svg";
import close_white from "../assets/media/icons/cross-thin-white.svg";

const visible = { opacity: 1, y: -50, transition: { duration: 1 } };

function ProgressBar({ value, max }) {
  return (
    <div className="progress-bar">
      <div className="progress-bar-completed" style={{ width: `${(value / max) * 100}%` }}></div>
    </div>
  );
}

export const ErrorTicket = (props) => {
  const context = useContext(AppContext);

  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <motion.article
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, transition: { duration: 1 } }}
      variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 500 },
          visible,
        }}
      >
        <div className="toast-error">
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <img src={!isDark ? error : error_dark} alt="error" />
            {props.notWhiteList ? (
              <span className="text-wrapper">
                This wallet address is not authorised, please refer to{" "}
                <a href={"mailto:contact@dwinity.com"}>contact@dwinity.com</a> for support.
              </span>
            ) : (
              <span className="text-wrapper">{props.text}</span>
            )}
          </div>
          <div className="actions-button-div">
            {props.actionsButton2 && (
              <button
                type="button"
                className="button subtle medium"
                onClick={() => {
                  props.setHideThem();
                }}
              >
                <span className="text p15" style={{ color: "var(--text-alert-secondary" }}>
                  {props.buttonText2}
                </span>
              </button>
            )}
            {props.actionsButton && (
              <button
                type="button"
                className="button alert medium"
                onClick={() => {
                  props.onDelete();
                }}
              >
                <span className="text p15">{props.buttonText}</span>
              </button>
            )}
          </div>
          <div className="close-button-div">
            <button className="button subtle medium" onClick={() => props.close()}>
              <img src={!isDark ? close_error : close_white} alt="error" />
            </button>
          </div>
        </div>
      </motion.div>
    </motion.article>
  );
};

export const WarningTicket = (props) => {
  const context = useContext(AppContext);

  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <motion.article
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, transition: { duration: 1 } }}
      variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 500 },
          visible,
        }}
      >
        <div className="toast-warning">
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <img src={!isDark ? warning : warning_dark} alt="error" />
            <span className="text-wrapper">{props.text}</span>
          </div>
          <div className="actions-button-div">
            {props.actionsButton2 && (
              <button
                type="button"
                className="button subtle medium"
                onClick={() => {
                  props.setHideThem();
                }}
              >
                <div className="text p15" style={{ color: "var(--text-warning-secondary" }}>
                  {props.buttonText2 ? props.buttonText2 : "Action"}
                </div>
              </button>
            )}
            {props.actionsButton && (
              <button
                type="button"
                className="button warning medium"
                onClick={() => {
                  props.onDelete();
                }}
              >
                <div className="text p15">{props.buttonText ? props.buttonText : "Action"}</div>
              </button>
            )}
          </div>
          <div className="close-button-div">
            <button className="button subtle medium" onClick={() => props.close()}>
              <img src={!isDark ? close_warning : close_white} alt="error" />
            </button>
          </div>
        </div>
      </motion.div>
    </motion.article>
  );
};

export const InformationsTicket = (props) => {
  const context = useContext(AppContext);

  const [isDark, setIsDark] = useState(true);
  const [progress, setProgress] = useState(0);

  const simulateProgress = () => {
    setProgress(progress + 100);
  };

  useEffect(() => {
    setTimeout(() => {
      simulateProgress();
    }, 800);
    setTimeout(() => {
      props.close();
      context.onSetInfoTicket("");
    }, 9000);
  }, []);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <motion.article
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, transition: { duration: 1 } }}
      variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 500 },
          visible,
        }}
      >
        <div className="toast-info">
          <img src={!isDark ? info : info_dark} alt="error" />
          <div className="text-wrapper">{props.text}</div>
          <div className="progress-div">
            <ProgressBar value={progress} max={100} />
          </div>
        </div>
      </motion.div>
    </motion.article>
  );
};

export const NotificationsTicket = (props) => {
  const context = useContext(AppContext);

  const [isDark, setIsDark] = useState(true);
  const [progress, setProgress] = useState(0);

  const simulateProgress = () => {
    setProgress(progress + 100);
  };

  useEffect(() => {
    setTimeout(() => {
      simulateProgress();
    }, 800);
    setTimeout(() => {
      props.close();
      context.onSetInfoTicket("");
    }, 9000);
  }, []);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <motion.article
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, transition: { duration: 1 } }}
      variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 500 },
          visible,
        }}
      >
        <div className="toast-done">
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <img src={!isDark ? done : done_dark} alt="error" />
            <span className="text-wrapper">{props.text}</span>
          </div>
          {props.actionsButton2 ||
            (props.actionsButton && (
              <div className="actions-button-div">
                {props.actionsButton2 && (
                  <button
                    type="button"
                    className="button subtle medium"
                    onClick={() => {
                      props.setHideThem();
                    }}
                  >
                    <div className="text p15" style={{ color: "var(--text-success-secondary" }}>
                      {props.buttonText2}
                    </div>
                  </button>
                )}
                {props.actionsButton && (
                  <button
                    type="button"
                    className="button succes medium"
                    onClick={() => {
                      props.onDelete();
                    }}
                  >
                    <div className="text p15">{props.buttonText}</div>
                  </button>
                )}
              </div>
            ))}
          <div className="progress-div">
            <ProgressBar value={progress} max={100} />
          </div>
          {props.actionsButton && (
            <div className="close-button-div">
              <button className="button subtle medium" onClick={() => props.close()}>
                <img src={!isDark ? close_done : close_white} alt="error" />
              </button>
            </div>
          )}
        </div>
      </motion.div>
    </motion.article>
  );
};
